import React from 'react'
import { useTranslation } from 'react-i18next'
import { PageHeader } from 'components/header/PageHeader'

export const CommunicationPreferences = () => {
  const { t } = useTranslation()

  return <PageHeader description={t('communicationPreferences.mainDescription')} />
}
